import React, { useState, useEffect, useRef, useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext.jsx'
import { THEMES } from '../config/themes.js'

const THEME_CHIPS = [
  { key: 'light',  label: 'Light',        swatch: '#EEF5EE' },
  { key: 'dark',   label: 'Dark',         swatch: '#1e1e1e' },
  { key: 'rainy',  label: 'Rainy Window', swatch: '#0e1f12' },
  { key: 'cafe',   label: 'Cosy Cafe',    swatch: '#2a1a08' },
  { key: 'quest',  label: 'Quest',        swatch: '#1a1030' },
]

const GearIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)

export default function SettingsDropdown() {
  const { themeName, setTheme } = useContext(ThemeContext)
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    function handleKey(e) {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [open])

  return (
    <div className="settings-dropdown-wrap" ref={ref}>
      <button
        className={`settings-gear-btn ${open ? 'open' : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-label="Settings"
        aria-expanded={open}
      >
        <GearIcon />
      </button>

      <div className={`settings-panel ${open ? 'visible' : ''}`} aria-hidden={!open}>
        <div className="settings-section-label">Theme</div>
        <div className="settings-theme-chips">
          {THEME_CHIPS.map(chip => (
            <button
              key={chip.key}
              className={`settings-chip ${themeName === chip.key ? 'active' : ''}`}
              onClick={() => setTheme(chip.key)}
              title={chip.label}
            >
              <span className="chip-swatch" style={{ background: chip.swatch }} />
              <span className="chip-label">{chip.label}</span>
            </button>
          ))}
        </div>

        <div className="settings-divider" />

        <div className="settings-section-label">Sounds</div>
        <div className="settings-toggles">
          <label className="settings-toggle-row">
            <span>Ambient sounds</span>
            <span className="settings-toggle-pill disabled">
              <span className="toggle-knob" />
            </span>
          </label>
          <label className="settings-toggle-row">
            <span>UI sounds</span>
            <span className="settings-toggle-pill disabled">
              <span className="toggle-knob" />
            </span>
          </label>
        </div>
        <div className="settings-coming-soon">Sound settings coming soon</div>
      </div>
    </div>
  )
}
